import { render } from "./panelData.vue?vue&type=template&id=1efbca43&scoped=true"
import script from "./panelData.vue?vue&type=script&lang=js"
export * from "./panelData.vue?vue&type=script&lang=js"

import "./panelData.vue?vue&type=style&index=0&id=1efbca43&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1efbca43"

export default script